import API from "../Api";
//login
export const apiLogin = (authForm) => API.post("/api/v1/auth/login", authForm);
export const apiUserAttempts = (authForm) => API.post("/api/v1/user/user-attempts", authForm);
export const apiLoginSac = (authForm) => API.post("/api/v1/auth/login-sac", authForm);
export const apiLogged = () => API.post("/api/v1/user/logged");
export const apiUserInfo = () => API.get(`/api/v1/user`);
export const apiUpdatePassword = (updateForm) => API.post(`/api/v1/auth/passwordchange`, updateForm);
export const apiCloseSession = () => API.post(`api/v1/auth/signOut`);
